<script setup lang="ts">
import WidgetRecordAction from '@components/widget/WidgetRecordAction.vue'

const { records, isSelected } = defineProps<{
  records: any[],
  isSelected: Function,
}>()

const emit = defineEmits(['set', 'getRecords', 'select', 'unselect', 'isSelected'])
</script>

<template>
  <VFragment>
    <VTable v-if="records?.length">
      <thead>
        <tr>
          <th>ID</th>
          <th>Название</th>
          <th class="text-center mw-100">
            Действие
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="record in records"
          :key="record.Uuid || record.Bundle.Uuid"
        >
          <td>
            <RouterLink
              :to="{ name: 'workplace', params: { uuid: record.Bundle.Uuid || record.Uuid }, query: { tab: 'preview'} }"
              target="_blank"
            >
              {{ record.Bundle.Id || record.Id }}
            </RouterLink>
          </td>
          <td>
            <RouterLink
              :to="{ name: 'workplace', params: { uuid: record.Bundle.Uuid || record.Uuid }, query: { tab: 'preview' } }"
              target="_blank"
            >
              {{ record.Title }}
            </RouterLink>
          </td>
          <td class="text-center">
            <WidgetRecordAction
              :selected="isSelected(record.Uuid || record.Bundle.Uuid)"
              @set="emit('select', record)"
              @delete="emit('unselect', record)"
            />
          </td>
        </tr>
      </tbody>
    </VTable>

    <VListItem v-else>
      Нет данных.
    </VListItem>
  </VFragment>
</template>

<style lang="scss" scoped>
.form-component-bottom {
  display: flex;
  align-items: center;
}

.form-component-bottom__pagination {
  flex-grow: 1;
}
</style>
